import { getUtmData, migrateUtmFromSessionStorage, setUtmData } from "./utmStorage"

const default_value = "organic"

const hasUtmParamsInUrl = (params) =>
  !!(
    params.utm_source ||
    params.utm_medium ||
    params.utm_campaign ||
    params.utm_content ||
    params.utm_term ||
    params.gclid ||
    params.fbc ||
    params.fbp
  )

const pickUtmField = (fromUrl, saved, fallback, urlHasUtms) => {
  if (urlHasUtms) {
    return fromUrl ?? saved ?? fallback
  }
  return saved ?? fallback
}

const resolveSourceId = (utmSource, captation_ways, savedSourceId) => {
  const defaultSourceId = parseInt(process.env.GATSBY_API_SOURCE_ID)

  if (!utmSource || utmSource === default_value) {
    return savedSourceId ?? defaultSourceId
  }

  if (utmSource.toLowerCase() === "geolocalizacion") {
    return 45
  }

  const objsource = captation_ways.data?.find(
    item => item.attributes.name.toLowerCase() === utmSource.toLowerCase()
  )

  if (objsource) {
    return parseInt(objsource.id)
  }

  return savedSourceId ?? defaultSourceId
}

const getParametersUrl = async () => {
  migrateUtmFromSessionStorage()

  const urlActual = window.location.href
  const url = new URL(urlActual)
  const parametros = new URLSearchParams(url.search)

  const utm_campaign = parametros.get("utm_campaign")
  const utm_content = parametros.get("utm_content")
  const utm_medium = parametros.get("utm_medium")
  const utm_source = parametros.get("utm_source")
  const utm_term = parametros.get("utm_term")
  const gclid = parametros.get("gclid")
  const fbc = parametros.get("fbc")
  const fbp = parametros.get("fbp")

  const urlParams = {
    utm_campaign,
    utm_content,
    utm_medium,
    utm_source,
    utm_term,
    gclid,
    fbc,
    fbp,
  }

  const urlHasUtms = hasUtmParamsInUrl(urlParams)
  const saved = getUtmData()

  const dataCaptationWaysJSON = localStorage.getItem("captation_ways")
  let captation_ways = {}

  if (!dataCaptationWaysJSON) {
    const response = await fetch(
      `${process.env.GATSBY_PAGINA_COMPILADOR}/wp-json/wp/v2/get/captation_ways`
    )
    const data = await response.json()
    captation_ways = JSON.parse(data)
    localStorage.setItem("captation_ways", data)
  } else {
    captation_ways = JSON.parse(dataCaptationWaysJSON)
  }

  const interest_type_id = parseInt(process.env.GATSBY_API_INTEREST_TYPE_ID)
  const input_channel_id = parseInt(process.env.GATSBY_API_INPUT_CHANNEL_ID)

  let client_ip_address = saved?.client_ip_address

  if (!client_ip_address) {
    const responseIpAddress = await fetch(
      `${process.env.GATSBY_PAGINA_COMPILADOR}/wp-json/ipAddress/v1/ip`
    )
    const ipData = await responseIpAddress.json()
    client_ip_address = ipData?.ip_address
  }

  const finalUtmSource = pickUtmField(
    utm_source,
    saved?.utm_source,
    default_value,
    urlHasUtms
  )

  const source_id = resolveSourceId(
    finalUtmSource,
    captation_ways,
    saved?.source_id
  )

  const obj_data = {
    utm_campaign: pickUtmField(
      utm_campaign,
      saved?.utm_campaign,
      default_value,
      urlHasUtms
    ),
    utm_content: pickUtmField(
      utm_content,
      saved?.utm_content,
      default_value,
      urlHasUtms
    ),
    utm_medium: pickUtmField(
      utm_medium,
      saved?.utm_medium,
      default_value,
      urlHasUtms
    ),
    utm_source: finalUtmSource,
    utm_term: pickUtmField(utm_term, saved?.utm_term, default_value, urlHasUtms),
    gclid: pickUtmField(gclid, saved?.gclid, "", urlHasUtms),
    source_id,
    interese_type_id: interest_type_id,
    input_channel_id: input_channel_id,
    client_ip_address,
    client_user_agent: window.navigator.userAgent,
    fbc: pickUtmField(fbc, saved?.fbc, "", urlHasUtms),
    fbp: pickUtmField(fbp, saved?.fbp, "", urlHasUtms),
  }

  if (!urlHasUtms && saved) {
    return
  }

  setUtmData(obj_data)
}

export default getParametersUrl
